import { useNavigate } from "react-router";
import { useContext } from "react";
import { DataContext } from "../../context/dataProvider";
import styles from './style.module.css';
import Button from "../../components/button";
import { HelpLink } from "../../common/help";

function FailPage() {
  const context = useContext(DataContext);
  const navigation = useNavigate();

  if (!context) {
    return null;
  }

  const movePrev = () => {
    navigation(-1);
  }

  const help =() => {
     window.location.href = HelpLink;
  }
  
  return (
    <div className="error">
      <div className={`content ${styles.container}`}>
        <div className={styles.backgroundContainer}>
          <img src="/images/fail-background.png" alt=""/>
        </div>
        <div className={styles.stick}>
          <div className={styles.text}>
            <h1>Ошибка</h1>
            <p>Что-то пошло не так, но мы работаем<br/>над исправлением ошибки</p>
          </div>
          <div className={styles.btns}>
            <Button label={'Обновить страницу'} onClick={() => movePrev()}/>
            <Button label={'Поддержка'} variant={"secondary"} onClick={() => help()}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FailPage;